import React from 'react';
import { useRedirect } from '@common/hooks/useRedirect';
import { useTranslation } from '@common/hooks/useTranslation';
import { AD_TYPE } from '@seek/je-shared-data';
import { SupportedCountryCode } from '@seek/je-shared-data/lib/types/brand';
import { getImmediateStartName } from '../../Job/EnhanceJob/components/getImmediateStartName';
import { MaxAdInfoWithUpgradeButton } from '../AdInfo';

type MaxAdCardProps = {
  adDuration?: number;
  price: React.ReactNode;
  countryCode: string;
  jobId: string;
  campaignId: string;
};

export const UpsellMaxAdCard = (props: MaxAdCardProps) => {
  const { adDuration, price, countryCode, jobId, campaignId } = props;
  const { redirect } = useRedirect();
  const { t } = useTranslation();

  const immediateStartText = t(
    getImmediateStartName(countryCode as SupportedCountryCode)
  );

  return (
    <div className={'flex flex-col p-md border'}>
      <div className="gap-md min-h-10">
        {/* No recommended badge for now, but still necessary to ensure equal spacing between cards that have the badge and cards that don't */}
      </div>

      <MaxAdInfoWithUpgradeButton
        adDuration={adDuration}
        price={price}
        immediateStartText={immediateStartText}
        onUpgradeButtonClicked={redirect(
          `/${countryCode}/jobs/${jobId}/enhance-job?campaign=${campaignId}&adType=${AD_TYPE.MAX}`
        )}
      />
    </div>
  );
};
